// Full searchable radio details from the supplied 2023 statewide channel plan.
export default String.raw`31.1|151.3850|110.9|159.3600|OST|H|N|CDF RRU LOCAL NET 1 WEST
31.2|151.1750|110.9|159.2850|OST|H|N|CDF RRU LOCAL NET 2
31.3|151.1300|94.8|158.9250|OST|H|N|CDF RRU LOCAL NET 3 INDIO
31.4|151.1300|88.5|158.9250|OST|H|N|CDF RRU LOCAL NET 3 BLYTHE
31.5|154.1000|000.0|156.0000|OST|H|N|RVC LOCAL CMD NET
31.6|151.0250|141.3|156.2400|OST|H|N|RVC LOCAL CMD NET
31.7|151.0550|000.0|156.1800|OST|H|N|RVC LOCAL CMD NET
31.8|154.4450|88.5|159.1500|OST|H|N|T1=CHUCKWALLA,T2=BLACK ROCK,T3=BIG MARIA
31.9|154.1450|167.9|159.2325|OST|H|N|T2=BOX SPRINGS, T13=PARADISE
31.10|154.4450|167.9|158.8200|OST|H|N|T1=SANTIAGO PK, T3= ELSINORE PK
31.11|154.1300|167.9|158.9550|OST|H|N|T12= MT DAVID
31.12|153.7700|167.9|155.6250|OST|H|N|T5-HEMET,T6-THOMAS,T8-PINE COVE,T14-RED MTN
31.13|154.1750|167.9|159.1875|OST|H|N|T10= WHITEWATER
31.14|154.7550|167.9|158.8350|OST|H|N|T4= CACTUS CITY
31.15|154.8000|167.9|159.2025|OST|H|N|T8= EDOM HILL
31.16|154.1750|141.3|158.9175|OST|H|N|RIVERSIDE CITY VHF TO UHF (T2-Box Spgs)
31.17|154.3400|192.8|154.3400|192.8|H|N|RVC TAC 1 B11 & COACHELLA
31.18|154.4150|192.8|154.4150|192.8|H|N|RVC TAC 2 B8 & WEST COUNTY
31.19|154.0100|192.8|154.0100|192.8|H|N|RVC TAC 3 COACHELLA ONLY
31.20|154.2500|192.8|154.2500|192.8|H|N|RVC TAC 4 COUNTYWIDE
31.21|159.0375|192.8|159.0375|192.8|H|N|RVC TAC 5 B1, 5, 9, 13
31.22|154.7100|167.9|154.7100|167.9|H|N|RVC TAC 6 B3, 5, 11
31.23|154.8600|167.9|154.8600|167.9|H|N|RVC TAC 7 B1,9,14,17
31.24|155.4900|123.0|155.4900|123.0|H|N|RVC TAC 8 B1,2,4,6,7,12,13,16,17
31.25|155.6550|167.9|155.6550|167.9|H|N|RVC TAC 9 B2,13,15
31.26|158.9475|192.8|158.9475|192.8|H|N|RVC TAC 10 B6,7,8,10,12,16
31.27|155.1900|192.8|155.1900|192.8|H|N|RVC TAC 11 - ALL BATT'S EXCEPT BLYTHE
31.28|158.8800|192.8|158.8800|192.8|H|N|LICENSED FOR USE AT BCTC ONLY!!
31.29|159.1575|192.8|159.1575|192.8|H|N|LICENSED FOR USE AT BCTC ONLY!!
31.30|151.13750|156.7|151.13750|156.7|L|N|VTAC 11
31.31|154.45250|156.7|154.45250|156.7|L|N|VTAC 12
31.32|158.73750|156.7|158.73750|156.7|L|N|VTAC 13
31.33|159.47250|156.7|159.47250|156.7|L|N|VTAC 14
31.34|154.26500|156.7|154.26500|156.7|L|N|VFIRE 22
31.35|154.29500|156.7|154.29500|156.7|L|N|VFIRE 23
31.36|154.27250|156.7|154.27250|156.7|L|N|VFIRE 24
31.37|154.28750|156.7|154.28750|156.7|L|N|VFIRE 25
31.38|154.30250|156.7|154.30250|156.7|L|N|VFIRE 26
31.39|151.8200|000.0|151.8200|000.0|L|N|HT ONLY Common user MURS / OLD TSC
31.40|151.8800|000.0|151.8800|000.0|L|N|HT ONLY Common user MURS / OLD TSC
31.41|151.9400|000.0|151.9400|000.0|L|N|HT ONLY Common user MURS / OLD TSC
31.42|151.35500|103.5|159.30000|OST|H|N|CDF CMD NET 1
31.43|151.26500|103.5|159.33000|OST|H|N|CDF CMD NET 2
31.44|151.34000|103.5|159.34500|OST|H|N|CDF CMD NET 3
31.45|151.1600|192.8|151.1600|192.8|L|N|CDF TAC 2
31.46|151.4000|192.8|151.4000|192.8|L|N|CDF TAC 10
31.47|151.4600|192.8|151.4600|192.8|L|N|CDF TAC 12
31.48|151.2200|192.8|151.2200|192.8|L|N|CDF Air to Ground #1
31.49|159.2625|192.8|159.2625|192.8|L|N|CDF Air to Ground #2
31.50|159.3675|192.8|159.3675|192.8|L|N|CDF Air to Ground #3
31.51|155.7000|192.8|155.7000|192.8|L|N|RVC AIR TO GROUND
31.52|156.0750|156.7|156.0750|156.7|H|N|CALCORD
31.53|155.1450|167.9|155.1450|167.9|H|N|CVDN-COACHELLA VALLEY DISASTER NET
31.54|155.2650|000.0|155.2650|110.9|H|N|Medic Use Only
31.55|155.2950|110.9|155.9100|D532|H|N|Medic Use Only- North- Box Springs
31.56|155.3550|110.9|155.9850|118.8|H|N|Medic Use Only- South - Elsinore Pk
31.57|155.2050|110.9|151.1150|88.5|H|N|Medic Use Only- Desert West- Whitewater
31.58|155.2050|110.9|151.1150|D114|H|N|Medic Use Only- Desert East- Indio Hill
31.59|155.2050|110.9|151.1150|D532|H|N|Medic Use Only- Desert Center - Chuckwalla
31.60|158.8500|000.0|154.8900|OST|H|N|RSO West County= T1, Blythe= T16
31.61|159.0900|000.0|158.7600|110.9|H|N|Coachella Valley
31.62|154.3550|123.0|153.8900|123.0|H|N|PALM SPRG LOCAL
31.63|154.3100|123.0|154.3100|123.0|H|N|PALM SPRG TAC
31.64|155.8950|123.0|155.8950|123.0|H|N|PALM SPRG TAC 2
31.65|155.9400|123.0|155.9400|123.0|H|N|PALM SPRG TAC 3 (TRAINING TAC)
31.66|154.4150|000.0|159.1650|131.8|H|N|CAT CITY LOCAL
31.67|154.4150|000.0|159.1650|114.8|H|N|CAT CITY LOCAL
31.68|154.2350|131.8|154.2350|131.8|H|N|CAT CITY TAC
31.69|158.7300|131.8|158.7300|131.8|H|N|CAT CITY TAC
31.70|156.0900|131.8|156.0900|131.8|H|N|CAT CITY TAC
31.71|154.2350|103.5|159.1650|103.5|H|N|CORONA
31.72|154.0400|114.8|156.0300|114.8|H|N|CORONA COMMAND
31.73|158.7450|103.5|158.7450|103.5|H|N|CORONA
31.74|158.8050|103.5|158.8050|103.5|H|N|CORONA
31.75|154.7850|103.5|154.7850|103.5|H|N|CORONA TAC
31.76|156.1500|103.5|156.1500|103.5|H|N|CORONA TAC
31.77|154.4000|146.2|154.4000|146.2|H|N|MURRIETA LOCAL
31.78|154.0400|146.2|150.7750|146.2|H|N|MURRIETA SUPPORT WEST
31.79|154.7400|146.2|159.2100|146.2|H|N|MURRIETA SUPPORT EAST
31.80|153.8300|146.2|153.8300|146.2|L|N|MURRIETA TAC 1
31.81|154.1450|146.2|154.1450|146.2|H|N|MURRIETA TAC 2
31.82|154.0100|123.0|150.7900|123.0|H|N|HEMET CITY LOCAL
31.83|154.1450|192.8|154.1450|192.8|H|N|HEMET CITY TAC 1
32.1|151.35500|103.5|159.30000|OST|H|N|T-1 Santiago, T-5 Strawberry
32.2|151.26500|103.5|159.33000|OST|H|N|T-1 Santiago, T-5 Strawberry
32.3|151.34000|103.5|159.34500|OST|H|N|T-2 Carbon Cyn, T-4 Sierra, T-5 Strawberry
32.4|151.01000|123.0|154.96500|123.0|H|N|
32.5|151.08500|136.5|159.0000|136.5|H|N|OC simulcast VHF
32.6|171.42500|103.5|164.80000|OST|H|N|
32.7|152.15000|151.4|158.61000|151.4|L|N|
32.8|152.24000|151.4|158.70000|151.4|L|N|
32.9|151.17500|110.9|159.28500|OST|H|N|
32.10|154.26500|156.7|154.26500|156.7|L|N|
32.11|154.29500|156.7|154.29500|156.7|L|N|
32.12|154.27250|156.7|154.27250|156.7|L|N|
32.13|154.28750|156.7|154.28750|156.7|L|N|
32.14|154.30250|156.7|154.30250|156.7|L|N|
32.15|154.40000|151.4|154.40000|151.4|L|N|TBD @ TIME OF DISP
32.16|151.22000|192.8|151.22000|192.8|L|N|TBD @ TIME OF DISP
32.17|159.36750|192.8|159.36750|192.8|L|N|TBD @ TIME OF DISP
32.18|168.62500|000.0|168.62500|110.9|L|N|Emergency
33.1|151.19000|131.8|159.22500|OST|H|N|SDU LOCAL NET 1
33.2|151.33250|131.8|159.27750|OST|H|N|SDU LOCAL NET 2
33.3|171.42500|103.5|164.80000|OST|H|N|CNF FOREST NET
33.4|171.13750|103.5|164.50000|OST|H|N|FS ADMIN NET
33.5|169.81250|000.0|166.32500|OST|H|N|US FISH & WILDLIFE
33.6|151.35500|103.5|159.30000|OST|H|N|CDF COMMAND 1
33.7|151.26500|103.5|159.33000|OST|H|N|CDF COMMAND 2
33.8|151.34000|103.5|159.34500|OST|H|N|CDF COMMAND 3
33.9|154.17500|103.5|158.86500|103.5|H|N|EAST ZONE
33.10|156.22500|107.2|159.01500|107.2|H|N|CENTRAL ZONE
33.11|153.99500|110.9|159.11250|OST|H|N|EAST ZONE
33.12|158.97000|103.5|155.55000|103.5|H|N|METRO ZONE
33.13|153.89000|156.7|150.80500|OST|H|N|NORTH ZONE
33.14|154.02500|131.8|158.74500|OST|H|N|NORTH ZONE
33.15|154.23500|156.7|158.98500|OST|H|N|NORTH ZONE
33.16|155.68500|156.7|158.80500|OST|H|N|ESCONDIDO
33.17|154.20500|103.5|155.38500|OST|H|N|CENTRAL ZONE
33.18|154.81500|103.5|158.83500|103.5|H|N|CHULA VISTA
33.19|150.61250|156.7|167.45000|OST|H|N|MCP
33.20|150.41250|156.7|166.50000|OST|H|N|MCP
33.21|155.10000|156.7|158.88000|OST|H|N|ESCONDIDO
33.22|153.93500|103.5|154.72500|103.5|H|N|METRO ZONE
33.23|155.19000|103.5|155.79000|OST|H|N|CENTRAL ZONE
33.24|155.77500|192.8|158.91000|OST|H|N|NORTH ZONE
33.25|153.81500|156.7|151.10000|OST|H|N|MCP
33.26|150.36250|000.0|167.30000|OST|H|N|MCP PORTABLE REPEATER
33.27|151.25750|192.8|151.25750|192.8|L|N|CDF TAC 1
33.28|151.25000|192.8|151.25000|192.8|L|N|CDF TAC 5
33.29|151.37000|192.8|151.37000|192.8|L|N|CDF TAC 8
33.30|155.08500|000.0|155.08500|103.5|L|N|CENTRAL ZONE
33.31|154.43000|103.5|154.43000|103.5|L|N|CENTRAL ZONE
33.32|154.14500|103.5|154.14500|103.5|L|N|METRO ZONE
33.33|154.31000|103.5|154.31000|103.5|L|N|METRO ZONE
33.34|154.25000|000.0|154.25000|000.0|L|N|NORTH ZONE
33.35|154.41500|000.0|154.41500|000.0|L|N|NORTH ZONE
33.36|159.16500|000.0|159.16500|000.0|L|N|NORTH ZONE
33.37|154.35500|000.0|154.35500|000.0|L|N|ESCONDIDO
33.38|156.01500|000.0|156.01500|000.0|L|N|LIFEGUARD
33.39|155.56500|000.0|155.56500|000.0|L|N|CHULA VISTA
33.40|156.18750|000.0|156.18750|000.0|L|N|EAST ZONE
33.41|158.94750|000.0|158.94750|000.0|L|N|EAST ZONE
33.42|154.38500|000.0|154.38500|110.9|L|N|NORTH ZONE
33.43|149.07500|000.0|149.07500|000.0|L|N|MCP
33.44|150.31250|000.0|150.31250|000.0|L|N|MCP
33.45|166.98750|000.0|166.98750|000.0|L|N|MCP
33.46|153.98000|000.0|153.98000|000.0|L|N|NORTH ZONE
33.47|155.6250|000.0|155.6250|000.0|L|N|CENTRAL ZONE
33.48|154.32500|103.5|154.32500|103.5|L|N|ESCONDIDO VHF INTEROP
33.49|172.37500|000.0|164.93750|OST|H|N|USFS Angeles NF
33.50|171.47500|000.0|168.15000|OST|H|N|USFS San Bernardino NF NEW
33.51|170.46250|000.0|164.91250|OST|H|N|USFS Los Padres NF
33.52|172.22500|000.0|164.78750|OST|H|N|USFS Sierra NF
33.53|169.90000|000.0|165.70000|OST|H|N|USFS Sequoia NF
33.54|166.55000|000.0|166.55000|000.0|L|N|FS R5 TAC 4
33.55|167.11250|000.0|167.11250|000.0|L|N|FS R5 TAC 5
33.56|168.23750|000.0|168.23750|000.0|L|N|FS R5 TAC 6
33.57|154.43000|110.9|153.77000|110.9|H|N|IMPERAL EAST
33.58|154.43000|110.9|153.77000|179.9|H|N|IMPERAL WEST
33.59|154.26500|156.7|154.26500|156.7|L|N|VFIRE 22
33.60|154.29500|156.7|154.29500|156.7|L|N|VFIRE 23
33.61|151.22000|192.8|151.22000|192.8|L|N|CDF Air to Ground 1
33.62|159.26250|192.8|159.26250|192.8|L|N|CDF Air to Ground 2
33.63|156.16500|107.2|156.16500|107.2|L|N|SAN DIEGO CO. A/G 1
33.64|156.12000|107.2|156.12000|107.2|L|N|SAN DIEGO CO. A/G 2 (NEW)
33.65|153.90500|107.2|153.90500|107.2|L|N|SAN DIEGO CO. A/G 3 (NEW)
33.66|168.48750|000.0|168.48750|000.0|L|N|FS AIR/GROUND 53
33.67|169.11250|000.0|169.11250|000.0|L|N|FS AIR/GROUND 59
33.68|168.62500|000.0|168.62500|110.9|L|N|Emergency`;
